import React from 'react';
import _ from 'lodash';
import { GetStaticPaths, GetStaticProps } from 'next';
import { fetchBrandSpacesListingData } from 'src/modules/brandSpaces';
import {
  BrandSpaceDetailsPage,
  BrandSpaceDetailsPageProps,
  fetchBrandSpacesDetailsData,
} from 'src/modules/brandSpaces/details';
import { useIntl } from 'react-intl';
import fs from 'fs';
import filterPathsListWithOutputChannel from 'src/utils/filterPathsListWithOutputChannel';

const PageProfessionalsBrandSpaceDetails: React.FunctionComponent<BrandSpaceDetailsPageProps> = (
  props
) => {
  const intl = useIntl();

  const parentBreadcrumbs = [
    {
      title: intl.formatMessage({
        id: 'breadcrumbs/professionals',
      }),
      as: '/professionals',
      href: '/professionals',
    },
    {
      title: intl.formatMessage({
        id: 'breadcrumbs/brand_spaces',
      }),
      as: '/professionals/brand-spaces',
      href: '/professionals/brand-spaces',
    },
  ];
  return <BrandSpaceDetailsPage parentBreadcrumbs={parentBreadcrumbs} {...props} />;
};

type Path = { params: { slug: string }; locale: string };

export const makeGetStaticPaths = (pathsListFileName: string) => {
  const getStaticPaths: GetStaticPaths = async () => {
    const data = await fetchBrandSpacesListingData('professionals');
    const stores = data?.stores || [];

    const pathsEn = _.map(stores, ({ slug }) => ({
      params: { slug },
      locale: 'en',
    }));

    const pathsDe = _.map(stores, ({ slug }) => ({
      params: { slug },
      locale: 'de',
    }));

    const paths = [
      ...(_.filter(pathsEn, (p) => p.params.slug) as Path[]),
      ...(_.filter(pathsDe, (p) => p.params.slug) as Path[]),
    ];

    const pathsList = filterPathsListWithOutputChannel(
      _.map(paths, (p) => `${p.locale}/professionals/brand-spaces/${p.params.slug}`)
    );

    fs.writeFileSync(
      `./public/data/paths/${pathsListFileName}.json`,
      JSON.stringify(pathsList, null, 2)
    );

    return { paths: [], fallback: true };
  };

  return getStaticPaths;
};

export const getStaticPaths = makeGetStaticPaths('professionals_brandspaces_slug');

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug as string;

  const data = await fetchBrandSpacesDetailsData(slug);

  return { props: { page: data?.stores?.[0] || null } };
};

export default PageProfessionalsBrandSpaceDetails;
